export const formatCurrency = (val,currency) =>{

    let formatted  = "";

    if(currency === "GC." || currency === "SC."){
        formatted = currency +  new Intl.NumberFormat("en-GB", { 
            style: 'currency',
            currency: "EUR",
            currencyDisplay: "code" 
        }).format(val).replace("EUR", "");
    }else{
        formatted = new Intl.NumberFormat("en-GB", { 
            style: 'currency',
            currency: currency
        }).format(val);
    }

    return formatted;
}